import { render, staticRenderFns } from "./CoPoPsoMapping.vue?vue&type=template&id=3e3687f5"
import script from "./CoPoPsoMapping.vue?vue&type=script&lang=js"
export * from "./CoPoPsoMapping.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports